import { SET_PRISMIC_DOCUMENT_UID } from 'dpl/actions/server';

export default function serverReducer(state = {}, action) {
  const {
    payload,
    type
  } = action;

  if (type === SET_PRISMIC_DOCUMENT_UID) {
    return {
      ...state,
      ...payload
    };
  }

  return state;
}
